/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const Error_ = core.serialization.object({
    key: core.serialization.string().optional(),
    message: core.serialization.string(),
});
